import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import type { TokenGetter } from '../api/client.api'

export const createBaseQueryWithAuth = (
  baseUrl: string,
  getToken?: TokenGetter
): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> =>
  fetchBaseQuery({
    baseUrl,
    prepareHeaders: async (headers) => {
      if (getToken) {
        const token = await getToken()
        if (token) {
          headers.set('Authorization', `Bearer ${token}`)
        }
      }
      return headers
    },
  })

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  tagTypes: ['User', 'Conversations', 'Conversation', 'Messages', 'Agencies', 'Agency'],
  endpoints: () => ({}),
})
